import { Button, Dropdown, Icon, Navbar } from "@storoey/sui";
import { useNavigate } from "@tanstack/solid-router";
import { createSignal, Show } from "solid-js";
import { useNavbar } from "../../contexts/RootContext";

export const AppNavbar = () => {
  const navigate = useNavigate();
  const { title } = useNavbar();

  const [triggerRef, setTriggerRef] = createSignal<HTMLButtonElement>();

  return (
    <Navbar>
      <Navbar.Left>
        <Show when={title() !== "Hjem"}>
          <Button
            leftIcon={<Icon>chevron_left</Icon>}
            size="small"
            variant="ghost"
            onClick={() => navigate({ to: ".." })}
          ></Button>
        </Show>
      </Navbar.Left>
      <Navbar.Center>
        <Navbar.Title title="Check-it" subtitle={title()} />
      </Navbar.Center>
      <Navbar.Right>
        <Dropdown triggerRef={triggerRef()} positionX="right">
          <Button
            ref={setTriggerRef}
            leftIcon={<Icon>settings</Icon>}
            size="small"
            variant="ghost"
          ></Button>
          <Dropdown.Menu>
            <Dropdown.Item
              icon={<Icon>style</Icon>}
              onClick={() => navigate({ to: "/settings" })}
            >
              Utseende
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              icon={<Icon>info</Icon>}
              onClick={() => navigate({ to: "/about" })}
            >
              Om
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Navbar.Right>
    </Navbar>
  );
};
